module.exports = __webpack_public_path__ + "assets/img/default_link.f5e19d20.jpg";